export default __webpack_public_path__ + "static/media/IBimageFootplantprojection2.30e7f74a.png";